'use strict';

$(function() {
    window.usedCarBookmarkList = new UsedCarBookmarkList();
    window.usedCarComparisonList = new UsedCarComparisonList();
});
